import {
    DashboardOutlined,
    CalculatorOutlined,
    TeamOutlined,
    SafetyOutlined,
    TruckOutlined,
    BookOutlined,
    FileUnknownOutlined,
    ProfileOutlined,
    CodeOutlined,
    LineChartOutlined,
    DatabaseOutlined,
    AlertOutlined,
    SettingOutlined,
    SisternodeOutlined,
    ForkOutlined,
    HistoryOutlined,
    ExceptionOutlined,
    HddOutlined,
    ReconciliationOutlined,
    ToolOutlined,
    FileDoneOutlined,
    WarningOutlined,
    ShoppingCartOutlined,
    DeploymentUnitOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig';

const dashBoardNavTree = [
    {
        key: 'dashboard',
        // path: `${APP_PREFIX_PATH}/fob`,
        title: 'sidenav.apps',
        icon: DashboardOutlined,
        breadcrumb: false,
        isGroupTitle: true,
        submenu: [
            {
                key: 'fob',
                code: 'FOB-R',
                path: `${APP_PREFIX_PATH}/fob`,
                title: 'apps.fob',
                icon: SafetyOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'mes',
                code: 'MES-R',
                path: `${APP_PREFIX_PATH}/mes`,
                title: 'apps.mes',
                icon: SisternodeOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'hrm',
                code: 'HRM-R',
                path: `${APP_PREFIX_PATH}/hrm`,
                title: 'apps.hrm',
                icon: TeamOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'acc',
                code: 'FIN-R',
                path: `${APP_PREFIX_PATH}/acc`,
                title: 'apps.fin',
                icon: CalculatorOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'fin',
                code: 'FIN-R',
                path: `${APP_PREFIX_PATH}/fin`,
                title: 'apps.fin_reports',
                icon: LineChartOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'repo',
                code: 'RE-R',
                path: `${APP_PREFIX_PATH}/re`,
                title: 'apps.re',
                icon: HddOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'tms',
                code: 'TMS-R',
                path: `${APP_PREFIX_PATH}/tms`,
                title: 'apps.tms',
                icon: TruckOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'asm',
                code: 'ASM-R',
                path: `${APP_PREFIX_PATH}/asm`,
                title: 'apps.asm',
                icon: ReconciliationOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'qas',
                code: 'QAS-R',
                path: `${APP_PREFIX_PATH}/qas`,
                title: 'apps.qas',
                icon: WarningOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'com',
                code: 'COM-R',
                path: `${APP_PREFIX_PATH}/com`,
                title: 'apps.com',
                icon: FileDoneOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'wss',
                code: 'WSS-R',
                path: `${APP_PREFIX_PATH}/wss`,
                title: 'apps.wss',
                icon: ShoppingCartOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'eof',
                code: 'EOF-R',
                path: `${APP_PREFIX_PATH}/eof`,
                title: 'apps.eof',
                icon: DeploymentUnitOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },

            // {
            //     key: 'util',
            //     code: 'UTIL-R',
            //     path: `${APP_PREFIX_PATH}/util`,
            //     title: 'apps.util',
            //     icon: ToolOutlined,
            //     breadcrumb: false,
            //     isGroupTitle: false,
            //     submenu: [],
            // },
        ],
    },
];

const systemManagementNavTree = [
    {
        key: 'sys-management',
        code: 'SYS-R',
        // path: `${APP_PREFIX_PATH}/fob`,
        title: 'apps.system',
        icon: DashboardOutlined,
        breadcrumb: false,
        isGroupTitle: false,
        submenu: [
            {
                key: 'util',
                code: 'UTIL-R',
                path: `${APP_PREFIX_PATH}/util`,
                title: 'apps.util',
                icon: ToolOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
            {
                key: 'sys',
                code: 'SYS_CAT-R',
                path: `${APP_PREFIX_PATH}/sys`,
                title: 'apps.system',
                icon: DatabaseOutlined,
                breadcrumb: false,
                isGroupTitle: false,
                submenu: [],
            },
        ],
    },
];

const docsNavTree = [
    {
        key: 'docs',
        path: `${APP_PREFIX_PATH}/docs`,
        title: 'sidenav.docs',
        icon: BookOutlined,
        breadcrumb: false,
        isGroupTitle: true,
        submenu: [
            {
                key: 'docs-documentation',
                path: `${APP_PREFIX_PATH}/docs/documentation`,
                title: 'docs.documentation',
                icon: FileUnknownOutlined,
                breadcrumb: false,
                submenu: [],
            },
            {
                key: 'docs-changelog',
                path: `${APP_PREFIX_PATH}/docs/documentation/changelog`,
                title: 'docs.changelog',
                icon: ProfileOutlined,
                breadcrumb: false,
                submenu: [],
            },
        ],
    },
];

const developmentNav = [
    {
        key: 'development',
        title: 'sidenav.dev',
        icon: BookOutlined,
        breadcrumb: false,
        isGroupTitle: true,
        code: 'DEV-R',
        submenu: [
            {
                key: 'dev-development-xml',
                code: 'DEV-R',
                path: `${APP_PREFIX_PATH}/dev/xml`,
                title: 'sidenav.dev.xml',
                icon: CodeOutlined,
                breadcrumb: false,
                submenu: [],
            },
            {
                key: 'dev-development-frontend',
                code: 'DEV-R',
                path: `${APP_PREFIX_PATH}/dev/frontend`,
                title: 'sidenav.dev.frontend',
                icon: CodeOutlined,
                breadcrumb: false,
                submenu: [],
            },
            // {
            //     key: 'dev-development-backend',
            //     // code: 'DEV-R',
            //     path: `${APP_PREFIX_PATH}/dev/backend`,
            //     title: 'sidenav.dev.backend',
            //     icon: CodeOutlined,
            //     breadcrumb: false,
            //     submenu: [],
            // },
        ],
    },
];

const navigationConfig = [...dashBoardNavTree, ...systemManagementNavTree, ...docsNavTree, ...developmentNav];

export default navigationConfig;
